export const SHARE_PLANNER_EVENTS = {
  RESET_SHAREABLE_LINK: "reset-shareable-link",
  RESET_PASSCODE: "reset-passcode",
  UNSHARE_FROM_USER: "unshare-from-user",
};
